module.exports = __webpack_public_path__ + "img/check-circle-outline.3c0f210c.svg";